<template>
<panel>
  <p slot="header">
    Dashboard
  </p>
  <div class="grid grid-full grid-pad">
    <div class="col-1-3">
      <div class="content">
        <ul class="uix-list">
          <li class="header">
            <h2>Wiadomości</h2></li>
          <li v-for="item in newslettersMenu"><a @click.prevent="$router.push({name: item.route})">{{ item.text }}</a></li>
        </ul>
      </div>
    </div>
    <div class="col-1-3">
      <div class="content">
        <ul class="uix-list">
          <li class="header">
            <h2>Grupy i adresy e-mail</h2></li>
          <li v-for="item in emailsMenu"><a @click.prevent="$router.push({name: item.route})">{{ item.text }}</a></li>
        </ul>
      </div>
    </div>
    <div class="col-1-3">
      <div class="content">
        <ul class="uix-list">
          <li class="header">
            <h2>Administracja</h2></li>
          <li v-for="item in adminMenu"><a @click.prevent="$router.push({name: item.route})">{{ item.text }}</a></li>
        </ul>
      </div>
    </div>
  </div>

</panel>

</template>
<script>
import { newslettersMenu, emailsMenu, adminMenu, myMenu } from './index'

export default {
  data () {
    return {
      newslettersMenu,
      emailsMenu,
      adminMenu,
      myMenu
    }
  }
}
</script>


// WEBPACK FOOTER //
// Dashboard.vue?47e5ab5c